import React, { useEffect } from 'react'
import { RawVideoData } from '../VideoPlayer/VideoPlayer.types'
import {
  fetchBrightcoveData,
  getVideoResourceUrl
} from '../../lib/fetchBrightcoveData'
import type { VideoThumbnailProps } from './VideoThumbnail.types'
import { VideoPoster } from '../VideoPoster/VideoPoster'
import './video-thumbnail.scss'

export const VideoThumbnail: React.FC<VideoThumbnailProps> = ({
  accountId,
  policyKey,
  playlistId,
  videoId,
  posterUrl: posterUrlProp,
  testId,
  onActivate,
  previewOnly = false
}) => {
  const [posterUrl, setPosterUrl] = React.useState<string | null>(
    posterUrlProp || null
  )

  useEffect(() => {
    if (posterUrlProp) return

    fetchBrightcoveData<RawVideoData & { videos?: RawVideoData[] }>(
      accountId,
      policyKey,
      getVideoResourceUrl(videoId, playlistId)
    )
      .then(playlist => {
        if (playlist?.videos && playlist.videos.length > 0) {
          setPosterUrl(playlist.videos[0].poster || null)
        }
      })
      .catch(() => {
        setPosterUrl(null)
      })
  }, [accountId, policyKey, playlistId, videoId, posterUrlProp])

  return posterUrl ? (
    <div className="VideoThumbnail" data-testid={testId}>
      <VideoPoster
        posterUrl={posterUrl}
        isLoading={false}
        isVisible={true}
        onActivate={onActivate || (() => {})}
        instanceLabel=""
        errorMessage=""
        previewOnly={previewOnly}
      />
    </div>
  ) : null
}
